const mqtt = require("mqtt");
import {v4 as uuidv4} from 'uuid';
import moment from "moment";

let mqttOptions = {
  connectTimeout: 3000,
  clientId: uuidv4(),
  username: 'ccnet',
  password: 'ccnet0901',
  clean: false,
}

var client = null;

// 网点消息队列
let posMsgList = {};

function setClientID(cliId){
  mqttOptions.clientId = cliId;
}


// mqtt连接和订阅,接收数据
function mqttConnect(topic, callback, userAccount) {
  if (!client) {
    client = mqtt.connect("wss://mqtt.nationaiot.com/mqtt", mqttOptions);
  }
  console.log('mqtt发起连接');
  // 连接
  client.on("connect", function () {
    console.log('mqtt连接成功');
    client.subscribe(topic, (error) => {
      console.log('mqtt订阅主题', topic);
      if (error) {
        console.log('mqtt订阅失败', error);
      } else {
        console.log('mqtt订阅成功');
      }
    });
  });

  client.on("message", function (topic, message) {
    console.log('接收消息的主题', topic);
    message = JSON.parse(message)
    console.log('接收消息', message ,userAccount);
    if(callback != null){      
      if (userAccount == message.userAccount) {
        callback(message);
      }
    }
    if(message.msg.indexOf("login") > 0){
      let msg = {
        msgID: uuidv4(),
        msgType: "chat_msg",
        timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
        from: 'omc',
        to: 'user',
        nickName: '管理员',
        msg: "小敏副驾欢迎您，按住页面底部麦克风可以与我对话。",
      }
      let topic = `ccnet/user/${message.userAccount}`
      console.log(topic);
      mqttPublish(topic, msg);
    }
  });
}

// mqtt发布数据
function mqttPublish(topic, msg) {
  if (!client) {
    client = mqtt.connect("wss://mqtt.nationaiot.com/mqtt", mqttOptions);
  }
  client.publish(topic, JSON.stringify(msg), (error) => {
    console.log('发送消息的主题', topic);
    if (error) {
      console.log('mqtt publish failure', error);
      alert(`消息发送失败${error}`);
    } else {
      console.log('mqtt publish success');
    }
  });
}

function mqttEnd() {
  if (client) {
    client.end();
    client = null;
    console.log('mqtt断开连接');
  }
}

export {
  mqttConnect,
  mqttPublish,
  mqttEnd,
  posMsgList,
  setClientID
}



// WEBPACK FOOTER //
// ./src/util/mqttMonitor.js